import { SendOutlined, CloseOutlined, CheckOutlined, EditOutlined, DeleteOutlined, DownloadOutlined, UndoOutlined  } from '@ant-design/icons';
import { Button, Col, Form, Row, Space, Tabs, Tag, Radio, FloatButton } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { dateCommon, validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Input } from 'antd/lib';
import { duyetDangKyNgoaiGio, duaYKienDonNgoaiGio, layChiTiet, xoaDonNgoaiGio, thuHoiNgoaiGio } from '../../services/ngoaigio';
import { DonNgoaiGio } from '../../models/ngoaigio/DonNgoaiGio';
import { trangThaiDonNgoaiGio } from '../../constants';
import { xuatDonNgoaiGio } from '../../services/report';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';

const XemThemGio = () => {
    const { TextArea } = Input;
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [donNgoaiGio, setDonNgoaiGio] = useState<DonNgoaiGio>( new DonNgoaiGio);
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuyet, setOpenModalDuyet] = useState(false);
    const [openModalXoa, setOpenModalXoa] = useState(false);
    const [openModalThuHoi, setOpenModalThuHoi] = useState(false);
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    const [reload, setReload] = useState(false);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");
    const [formDuaYKien] = useForm();
    const [trangThaiTag, setTrangThaiTag] = useState<JSX.Element>();
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [noiDungYKien, setNoiDungYKien] = useState<string>("");
    const [noiDungPheDuyet, setNoiDungPheDuyet] = useState<string>("");
    const layCT = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            if (id > 0) {
                var donNgoaiGio = await layChiTiet(id);
                setDonNgoaiGio(donNgoaiGio);
                switch (donNgoaiGio.trangThai) {
                    case trangThaiDonNgoaiGio.khoiTao: setTrangThaiTag(<Tag color="processing">Khởi tạo</Tag>); break;
                    case trangThaiDonNgoaiGio.trinh: setTrangThaiTag(<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                    case trangThaiDonNgoaiGio.daDuyet: setTrangThaiTag(<Tag color="success">Đã Duyệt</Tag>); break;
                    case trangThaiDonNgoaiGio.tuChoi: setTrangThaiTag(<Tag color="error">Từ chối</Tag>); break;
                    case trangThaiDonNgoaiGio.yKien: setTrangThaiTag(<Tag color="orange">Lấy ý kiến</Tag>); break;
                }
                var ndYKien = donNgoaiGio.logs.filter((item) => item.idNguoiDung == donNgoaiGio.idNguoiYKien)
                if (ndYKien.length > 0) {
                    setNoiDungYKien(ndYKien[0].chiTiet)
                }
                var ndPheDuyet = donNgoaiGio.logs.filter((item) => item.idNguoiDung == donNgoaiGio.idNguoiDuyet)
                if (ndPheDuyet.length > 0) {
                    setNoiDungPheDuyet(ndPheDuyet[0].chiTiet)
                }
            }
        }
        catch (error: any) {
            toast.error("Đơn thêm giờ không tồn tại hoặc bạn không có quyền xem!");
            navigate(Links.NgoaiGio.DanhSach);
        }
        dispatch(hideLoadingScreen());
    }
 
    const onDuaYKien = async () => {
        formDuaYKien.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                await duaYKienDonNgoaiGio({
                    id: donNgoaiGio.id,
                    isDuyet: values.duyet,
                    noiDung: values.noiDung || ""
                });
                toast.success("Đưa ý kiến thành công.");
                setReload(true);
            } catch (ex: any) {
                toast.error(ex);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

            dispatch(hideLoadingScreen());
        })
    }

    const xuatBaoCao = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatDonNgoaiGio(id);
            let link = document.createElement('a');

            link.download = donNgoaiGio.tenNhanVien + `_ThemGio.docx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            dispatch(hideLoadingScreen());
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const xoa = async () => {
        try {
            dispatch(showLoadingScreen());
            await xoaDonNgoaiGio(parseInt(id));
            dispatch(hideLoadingScreen());
            setOpenModalXoa(false);
            toast.success('Xóa đơn thêm giờ thành công');
            navigate(Links.NgoaiGio.DanhSach);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error('Xóa đơn thêm giờ không thành công! Vui lòng thử lại.');
        };
    };

    const eventPheDuyet = async (duyet: boolean) => {
        try { 
            await duyetDangKyNgoaiGio({
                id: donNgoaiGio.id,
                isDuyet: duyet,
                noiDung: lyDoTuChoi

            });
            toast.success("Phê duyệt đơn nghỉ phép thành công.");
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const eventThuHoiNgoaiGio = async () => {
        try {
            await thuHoiNgoaiGio(donNgoaiGio.id);
            dispatch(hideLoadingScreen());
            setReload(true);
            setOpenModalThuHoi(false);
            toast.success("Thu hồi đơn thêm giờ thành công.");
        } catch (error: any) {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        }
    }

    useEffect(() => {
        if (parseInt(id) > 0) {
            formDuaYKien.setFieldValue('duyet', true);
            layCT(parseInt(id));
        }
    }, []);

    useEffect(() => {
        if (reload) {
            if (parseInt(id) > 0) {
                layCT(parseInt(id));
            }
            setReload(false);
        }
    }, [reload]);

    return (
        <section style={{ paddingBottom: "60px" }}>
            <ContentHeader title="Đơn thêm giờ" />
                {openModalXoa && <ModalTextForm show={openModalXoa}
                    title="Xoá đơn thêm giờ"
                    handleClose={() => setOpenModalXoa(false)}
                    handleSave={() => xoa()}>
                    Bạn có đồng ý xóa đơn thêm giờ này không?
                    </ModalTextForm>}
                {openModalThuHoi && <ModalTextForm show={openModalThuHoi}
                    title="Thu hồi đơn thêm giờ"
                    handleClose={() => setOpenModalThuHoi(false)}
                handleSave={() => eventThuHoiNgoaiGio()}>
                    Bạn có muốn thu hồi đơn thêm giờ này không?
                </ModalTextForm>}
                {openModalDuyet && <ModalTextForm show={openModalDuyet}
                    title="Đồng ý phê duyệt đơn thêm giờ"
                    handleClose={() => setOpenModalDuyet(false)}
                    handleSave={() => { eventPheDuyet(true); setOpenModalDuyet(false); }}>
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Đồng ý </label> phê duyệt đơn thêm giờ này không? Hãy nhập nội dung (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                        </Col>
                    </Row>
                </ModalTextForm>}
                {openModalTuChoi && <ModalTextForm show={openModalTuChoi}
                    title="Từ chối phê duyệt đơn nghỉ phép"
                    handleClose={() => setOpenModalTuChoi(false)}
                    handleSave={() => { eventPheDuyet(false); setOpenModalTuChoi(false); }}>
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Từ chối</label> phê duyệt đơn thêm giờ này không? Hãy nhập lý do (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                        </Col>
                    </Row>
                </ModalTextForm>}
                {openModalYKien && <ModalTextForm show={openModalYKien}
                    title="Đưa ý kiến cho đơn thêm giờ"
                    handleClose={() => setOpenModalYKien(false)}
                    handleSave={() => { onDuaYKien(); setOpenModalYKien(false); }}>
                    <Form
                        form={formDuaYKien}
                        onFinish={() => { }}
                        validateMessages={validateMessages}
                    >
                        <Form.Item label="Ý kiến" name="duyet" rules={[{ required: true }]}>
                            <Radio.Group>
                                <Radio value={true}>Đồng ý</Radio>
                                <Radio value={false}>Từ chối</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="Nội dung ý kiến"
                            name="noiDung"
                        >
                            <TextArea placeholder="Nội dung" />
                        </Form.Item>
                    </Form>
            </ModalTextForm>}
            <Space style={{ position: "fixed", zIndex: 1, right: "24px", top: "100px" }} >
                {
                    donNgoaiGio.quyenPheDuyet
                    && <>
                        <Button type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                            onClick={() => {
                                setLyDoTuChoi("");
                                setOpenModalTuChoi(true);
                            }}
                        >
                            Không duyệt
                        </Button>
                        <Button type="primary" className="float-right" htmlType="button" icon=<CheckOutlined rev="" />
                            onClick={() => { setLyDoTuChoi(""); setOpenModalDuyet(true); }}>
                            Duyệt
                        </Button>
                    </>
                }
                {
                    donNgoaiGio.quyenYKien &&
                    <Button
                        type="primary"
                        icon={<SendOutlined rev="" />}
                        onClick={() => {
                            setOpenModalYKien(true);
                        }}
                    >
                        Đưa ý kiến
                    </Button>
                }
                {
                    (donNgoaiGio.trangThai == trangThaiDonNgoaiGio.trinh || donNgoaiGio.trangThai == trangThaiDonNgoaiGio.yKien) && donNgoaiGio.idNhanVien == user.idNhanVien &&
                    <Button
                        type="primary"
                        className="hrm-btn-warning"
                        icon={<UndoOutlined rev="" />}
                        onClick={() => {
                            setOpenModalThuHoi(true);
                        }}
                    >
                        Thu hồi
                    </Button>
                }
            </Space>
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Tabs
                                defaultActiveKey="1" items={[
                                    {                                     
                                        key: '1',
                                        label: <span>Thông tin </span>,
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <div>Trạng thái</div>
                                                            <label>{trangThaiTag}</label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div>Ngày tạo</div>
                                                            <label>{dateCommon.formatDate(donNgoaiGio?.ngayKhoiTao)}</label>
                                                        </Col>
                                                        {
                                                            donNgoaiGio?.ngayCapNhat != null &&
                                                            <Col span={8}>
                                                                <div>Ngày cập nhật</div>
                                                                    <label>{dateCommon.formatDate(donNgoaiGio?.ngayCapNhat != null ? donNgoaiGio?.ngayCapNhat : "Không có")}</label>
                                                            </Col>
                                                        }
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <div>Nhân viên</div>
                                                            <label>{donNgoaiGio?.tenNhanVien}</label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div>Người ý kiến</div>
                                                            <label>
                                                                {donNgoaiGio?.tenNguoiYKien != null ? donNgoaiGio?.tenNguoiYKien : "Không có"}
                                                            </label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div>Người duyệt</div>
                                                            <label>{donNgoaiGio?.tenNguoiDuyet}</label>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <div>Kính gửi</div>
                                                            <label>{donNgoaiGio?.kinhGui}</label>
                                                        </Col>
                                                        <Col span={16}>
                                                            <div>Lý do</div>
                                                            <label>
                                                                {donNgoaiGio?.lyDo}
                                                            </label>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <div>Ngày làm thêm giờ</div>
                                                            <label>{dateCommon.formatDate(donNgoaiGio?.ngay)}</label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div>Số giờ đăng ký</div>
                                                            <label>{donNgoaiGio?.soGio}</label>
                                                        </Col>
                                                        <Col span={8}>
                                                            <div>Địa điểm làm việc</div>
                                                            <label>
                                                                {donNgoaiGio?.diaDiemLamViec}
                                                            </label>
                                                        </Col>
                                                    </Row>
                                                    {noiDungYKien != "" && noiDungYKien != null &&
                                                        <Row gutter={24}>
                                                            <Col span="16">
                                                                <div>Nội dung ý kiến</div>
                                                                <label>{noiDungYKien}</label>
                                                            </Col>
                                                        </Row>
                                                    }
                                                    {noiDungPheDuyet != "" && noiDungPheDuyet != null &&
                                                        <Row gutter={24}>
                                                            <Col span="16">
                                                                <div>Nội dung phê duyệt</div>
                                                                <label>{noiDungPheDuyet}</label>
                                                            </Col>
                                                        </Row>
                                                    }
                                                </Col>
                                            </Row>

                                    },
                                    {
                                        key: '2',
                                        label: "Lịch sử thao tác",
                                        children: <LogNguoiDungTable data = {donNgoaiGio?.logs} />
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="card-outline">

                            <Row className="mt-1 mb-1">
                                <Col span="24">
                                    <FloatButton.Group
                                        trigger="hover"
                                        type="primary"
                                        style={{ right: 50, bottom: 80 }}
                                    > {donNgoaiGio.quyenSua &&
                                        <>
                                            <FloatButton
                                                tooltip="Chỉnh sửa đơn thêm giờ"
                                                className="hrm-btn-warning"
                                                icon={<EditOutlined rev="" />}
                                                onClick={() => {
                                                    navigate(Links.NgoaiGio.DangKy + "?id=" + id);
                                                }}
                                            />
                                            <FloatButton
                                                tooltip="Xóa đơn thêm giờ"
                                                className="hrm-btn-delete"
                                                icon={<DeleteOutlined rev="" />}
                                                onClick={() => setOpenModalXoa(true)}
                                            />
                                        </>
                                        }
                                        <FloatButton
                                            tooltip="Tải đơn thêm giờ"
                                            className="hrm-btn-success"
                                        icon={<DownloadOutlined rev="" />}
                                        onClick={() => { xuatBaoCao(donNgoaiGio.id) }}
                                        />
                                    </FloatButton.Group>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
        </section>
    );
};

export default XemThemGio;
